import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Text2 = forwardRef<SVGSVGElement, IconProps>(
  ({ size, color, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2.5C2 2.22386 2.22386 2 2.5 2H13.5C13.7761 2 14 2.22386 14 2.5V4.16667C14 4.44281 13.7761 4.66667 13.5 4.66667C13.2239 4.66667 13 4.44281 13 4.16667V3H8.5V13H9.5C9.77613 13 10 13.2239 10 13.5C10 13.7761 9.77613 14 9.5 14H6.5C6.22386 14 6 13.7761 6 13.5C6 13.2239 6.22386 13 6.5 13H7.5V3H3V4.16667C3 4.44281 2.77614 4.66667 2.5 4.66667C2.22386 4.66667 2 4.44281 2 4.16667V2.5Z"
        fill={color || 'currentColor'}
      />
    </svg>
  ),
)
Text2.displayName = 'Text2'

export default Text2
